<template>
  <div>
    <section class="sub-banner01 banner-top02 position-relative float-start w-100">
      <TitAndBread></TitAndBread>
    </section>
    <main class="float-start w-100">
      <section class="parnas-div d-inline-block w-100">
        <div class="container">
          <div class="comon-peice-div">
            <div class="row align-items-center g-5">
              <div class="col-lg-5">
                <h6 class="subt-text"> 开启体验</h6>
                <h2 class="main-head-text text-white mt-3"> 免费体验 </h2>
                <p class="sub-para text-color">
                  免费套餐是为用户提供基本对话功能的服务。用户可以通过免费套餐进行简单的对话交流，获取一般性的信息和帮助。免费套餐适合于个人用户体验，能够满足日常生活和工作中的基本需求。不收取任何费用，方便用户初步体验AI智能对话的便利与实用性。
                </p>
                <h2 class="main-head-text text-white mt-3"> 3天畅聊 </h2>
                <p class="sub-para text-color">
                  为用户提供短期服务，更加全面的AI助理功能体验。用户可以在3天的时限内畅享更多功能，包括智能日程安排、个性化对话等。3天套餐适合于需要在特定时间内获得更多帮助和支持的用户。 </p>
              </div>
              <div class="col-lg-7">
                <div class="pricing">
                  <div class="plan">
                    <h2>免费套餐</h2>
                    <div class="price">￥0</div>
                    <h5>支持10次对话</h5>
                    <ul class="features">
                      <li><i class="fas fas fa-times-circle"></i> 对话次数不限</li>
                      <li><i class="fas fa-check-circle"></i> 7X24小时在线</li>
                      <li><i class="fas fa-check-circle"></i> 丰富的场景化对话</li>
                      <li><i class="fas fa-check-circle"></i> 查看和下载历史对话</li>
                      <li><i class="fas fa-check-circle"></i> 收藏对话内容</li>
                    </ul>
                    <button data-bs-toggle="modal" data-bs-target="#loginModal">立即购买
                      <span class="btnImg">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                          class="bi bi-arrow-up-short" viewbox="0 0 16 16">
                          <path fill-rule="evenodd"
                            d="M8 12a.5.5 0 0 0 .5-.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 .5.5z">
                          </path>
                        </svg>
                      </span>
                    </button>
                  </div>
                  <div class="plan">
                    <h2>三天套装</h2>
                    <div class="price">￥9.9 / <small>3天</small></div>
                    <h5>体验版本 </h5>
                    <ul class="features">
                      <li><i class="fas fa-check-circle"></i> 对话次数不限</li>
                      <li><i class="fas fa-check-circle"></i> 7X24小时在线</li>
                      <li><i class="fas fa-check-circle"></i> 丰富的场景化对话</li>
                      <li><i class="fas fa-check-circle"></i> 查看和下载历史对话</li>
                      <li><i class="fas fa-check-circle"></i> 收藏对话内容</li>
                    </ul>
                    <button data-bs-toggle="modal" data-bs-target="#loginModal">立即购买
                      <span class="btnImg">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                          class="bi bi-arrow-up-short" viewbox="0 0 16 16">
                          <path fill-rule="evenodd"
                            d="M8 12a.5.5 0 0 0 .5-.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 .5.5z">
                          </path>
                        </svg>
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row justify-content-start flex-row-reverse my-5 g-5">
              <div class="col-lg-5">
                <h6 class="subt-text"> 升级体验 </h6>
                <h2 class="main-head-text text-white mt-3"> 周卡畅聊 </h2>
                <p class="sub-para text-color">
                  周卡畅聊为用户提供灵活使用时间的服务。用户可以在一周的时限内随时随地享受各项功能和服务。周卡套餐适合于需要长时间、连续使用用户，例如需要在工作日或周末期间持续获取帮助和支持的个人或团队。用户可以通过周卡，方便快捷地使用AI智能对话服务。
                </p>
                <h2 class="main-head-text text-white mt-3"> 月卡畅聊 </h2>
                <p class="sub-para text-color">
                  月卡畅聊为用户提供长期持续使用服务的计划。用户可以在一个月的时限内充分利用各项功能，包括定制化服务、数据分析、智能决策支持等。月卡套餐适合于需要长期、稳定使用用户，例如个人用户、企业团队或专业人士。用户可以通过月卡，享受AI智能对话长期、稳定的卓越服务。
                </p>
              </div>
              <div class="col-lg-7">
                <div class="pricing justify-content-start">
                  <div class="plan">
                    <h2>周卡套餐</h2>
                    <div class="price">￥19.9 / <small>周</small></div>
                    <h5>普通版本</h5>
                    <ul class="features">
                      <li><i class="fas fa-check-circle"></i> 对话次数不限</li>
                      <li><i class="fas fa-check-circle"></i> 7X24小时在线</li>
                      <li><i class="fas fa-check-circle"></i> 丰富的场景化对话</li>
                      <li><i class="fas fa-check-circle"></i> 查看和下载历史对话</li>
                      <li><i class="fas fa-check-circle"></i> 收藏对话内容</li>
                    </ul>
                    <button data-bs-toggle="modal" data-bs-target="#loginModal">立即购买
                      <span class="btnImg">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                          class="bi bi-arrow-up-short" viewbox="0 0 16 16">
                          <path fill-rule="evenodd"
                            d="M8 12a.5.5 0 0 0 .5-.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 .5.5z">
                          </path>
                        </svg>
                      </span>
                    </button>
                  </div>
                  <div class="plan">
                    <h2>月卡套餐</h2>
                    <div class="price">￥69 / <small>月</small></div>
                    <h5>加长版本</h5>
                    <ul class="features">
                      <li><i class="fas fa-check-circle"></i> 对话次数不限</li>
                      <li><i class="fas fa-check-circle"></i> 7X24小时在线</li>
                      <li><i class="fas fa-check-circle"></i> 丰富的场景化对话</li>
                      <li><i class="fas fa-check-circle"></i> 查看和下载历史对话</li>
                      <li><i class="fas fa-check-circle"></i> 收藏对话内容</li>
                    </ul>
                    <button data-bs-toggle="modal" data-bs-target="#loginModal">立即购买
                      <span class="btnImg">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                          class="bi bi-arrow-up-short" viewbox="0 0 16 16">
                          <path fill-rule="evenodd"
                            d="M8 12a.5.5 0 0 0 .5-.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 .5.5z">
                          </path>
                        </svg>
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="d-inline-block getst-work-home-06 w-100">
        <div class="container position-relative">
          <FooterHint></FooterHint>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import TitAndBread from '@/components/TitAndBread';
import FooterHint from '@/components/FooterHint';
export default {
  name: '',
  components: { TitAndBread, FooterHint },
  props: {},
  data() {
    return {
    }
  },
  computed: {},
  watch: {},
  created() { },
  mounted() { },
  methods: {}
}
</script>

<style scoped lang="less">
.btnImg {
  svg {
    transform: rotate(45deg) scale(2) !important;
    padding-top: 8px;
    padding-left: 8px;
  }
} 
</style>
